import React, {useState} from "react";
import * as PropTypes from "prop-types";
import ImageUploading from "react-images-uploading";
import '../../resources/css/application.css';
import ConfirmationDialog from "../popup/ConfirmationDialog";
import FormHelperText from "@material-ui/core/FormHelperText";
import {ALLOWED_IMAGE_EXTENSIONS, ENV} from "../../util/Util";

const uploadButtonStyle = (disabledButton, dragging, errors, submitFlag, image) => {
  if (!disabledButton && dragging) {
    return "upload-btn upload-btn-dragging";
  }
  if (errors || (submitFlag && image === null)) {
    return "upload-btn upload-btn-has-error";
  }
  return "upload-btn";
};

const getFileName = (imageName) => {
  return (
    <p className="placeholder-text upload-btn-check-mark"><strong
      className={"text-primary"}>{imageName}</strong></p>
  )
};

const getFieldPlaceholder = () => {
  return (
    <p className="placeholder-text"><strong className={"text-primary"}>Kliknite ovdje</strong>​ ili povucite
      i ispustite datoteku za prijenos</p>
  )
};

const ImageUpload = (props) => {

  const {images, setImages, propertyNameInState, index, newImageName, submitFlag, fieldRefs} = props;
  const [selectedImage, setSelectedImage] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  const onOpenDeleteDialog = () => {
    setSelectedImage(images[index]);
    setDialogOpen(true);
  };

  const onCloseDeleteDialog = () => {
    setDialogOpen(false);
  };

  const renameFile = (originalFile, newName) => {
    return new File([originalFile], newName + "." + originalFile.name.split(".")[1], {
      type: originalFile.type,
      lastModified: originalFile.lastModified,
    });
  };

  const addImage = (value) => {
    if (!images[index]) {
      value.file = renameFile(value.file, newImageName);
      const old = images[index];
      const updated = {...old, dataURL: value.dataURL, file: value.file};
      const clone = [...images];
      clone[index] = updated;
      setImages(propertyNameInState, clone);
    }
  };

  const removeImage = () => {
    const clone = [...images];
    clone[index] = null;
    setImages(propertyNameInState, clone);
    onCloseDeleteDialog();
  };

  return (
    <div>

      <ImageUploading
        onChange={value => addImage(value[0])}
        maxFileSize={ENV.REACT_APP_UPLOAD_MAX_SIZE}
        acceptType={ALLOWED_IMAGE_EXTENSIONS}>
        {({onImageUpload, isDragging, dragProps, errors}) => (
          <div>

            <button
              className={uploadButtonStyle(images[index], isDragging, errors, submitFlag, images[index])}
              disabled={images[index]}
              onClick={onImageUpload}
              ref={instance => fieldRefs.current[index] = instance}
              {...dragProps}>
              {images[index] ? getFileName(newImageName) : getFieldPlaceholder()}
              {images[index] && <p onClick={onOpenDeleteDialog} className="upload-delete-icon"/>}
            </button>

            {<div className="error-text">
              <FormHelperText error={errors && errors.maxFileSize && !images[index]}>
                {errors && errors.maxFileSize ? "Maksimalna dozvoljena veličina pojedine priložene datoteke je 5 MB" : null}
              </FormHelperText>
            </div>}

            {<div className="error-text">
              <FormHelperText error={errors && errors.acceptType && !images[index]}>
                {errors && errors.acceptType ? "Priložena datoteka nije ispravnog formata. Dozvoljeni format priloženog dokumenta je jpg/jpeg slika." : null}
              </FormHelperText>
            </div>}

          </div>
        )}
      </ImageUploading>

      {selectedImage && <ConfirmationDialog open={dialogOpen}
                                            onClose={onCloseDeleteDialog}
                                            onClick={removeImage}
                                            title={"Jeste li sigurni da želite izbrisati učitani dokument?"}
                                            message={"dokument:"}
                                            boldMessage={selectedImage.file.name}
                                            submitButtonText={"Izbriši dokument"}/>}

    </div>
  );
};

ImageUpload.propTypes = {
  images: PropTypes.array.isRequired,
  setImages: PropTypes.func.isRequired,
  propertyNameInState: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  newImageName: PropTypes.string.isRequired,
  submitFlag: PropTypes.bool,
  fieldRefs: PropTypes.object
};

export default ImageUpload;
